/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b3590498f27897ece10b7c0b07b914d5346e0219";
